export const GET_ALL_DOCS_METADATA = `
  query GetAllDocsMetadata {
    allDocsSections(first: 100) {
      id
      title
      slug
      displayOrder
      summary
      icon
      isVisible
      parentSection {
        id
      }
    }
    allDocsArticles(first: 100) {
      id
      title
      slug
      displayOrder
      isVisible
      section {
        id
      }
    }
  }
`

export const GET_DOC_ARTICLE_BODY = `
  query GetDocArticleBody($articleId: ItemId) {
    allDocsArticles(filter: {id: {eq: $articleId}}, first: 1) {
      id
      body
    }
  }
`

/** Single article (title and body) looked up directly by its slug. */
export const GET_DOC_ARTICLE_BY_SLUG = `
  query GetDocArticleBySlug($slug: String!) {
    docsArticle(filter: {slug: {eq: $slug}}) {
      id
      title
      slug
      body
      articlevideo {
        title
        video {
          streamingUrl
          thumbnailUrl(format: jpg)
          mp4Url
          duration
          width
          height
          blurUpThumb
        }
      }
    }
  }
`

export const SEARCH_DOCS_ARTICLES = `
  query SearchDocsArticles($pattern: String!) {
    allDocsArticles(
      filter: {
        OR: [
          { title: { matches: { pattern: $pattern, caseSensitive: false } } }
          { body: { matches: { pattern: $pattern, caseSensitive: false } } }
        ]
      }
      first: 20
    ) {
      id
      title
      slug
      section {
        id
        title
        slug
      }
    }
  }
`
